/**
 * i18n設定とエクスポート
 * メイン言語: 英語 (en)
 * サブ言語: 日本語 (ja)
 */
export { en, type Translations } from './en';
export { ja } from './ja';

/** サポートされる言語コード */
export type Locale = 'en' | 'ja';

/** デフォルト言語は英語 */
export const defaultLocale: Locale = 'en';
